export default __webpack_public_path__ + "static/media/searinghatred.8a76e272.png";